import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_PREFIX, JSON_CONTENT_TYPE_HEADER } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { emojiCategories } from './emojis';
import { EmojiUsage, MostUsedEmojis } from './most-used-emojis';

@Injectable({
  providedIn: 'root',
})
export class EmojisService {
  private emojiIndexes = {}; // index of our emojis in the sprite (allEmojis.jpg)

  constructor(
    private http: HttpClient,
    private alcmeonContext: AlcmeonContextService,
    private ehs: ErrorHandlingService
  ) {
    let index = 0;
    for (const category of this.allEmojisByCategory()) {
      for (const emoji of category.charList) {
        this.emojiIndexes[emoji] = index++;
      }
    }
  }

  allEmojisByCategory() {
    return emojiCategories;
  }

  emojiIndex(emoji) {
    return this.emojiIndexes[emoji];
  }

  getUsageCounts(): Observable<MostUsedEmojis> {
    return this.http.get<EmojiUsage[]>(this.endpointURL()).pipe(
      map(response => response || []),
      map(usages => usages.map(usage => new EmojiUsage(usage.emoji, usage.usageCount))),
      map(usages => new MostUsedEmojis(usages)),
      this.ehs.catchAlertAndThrowHttpError()
    );
  }

  updateUsageCounts(counts: MostUsedEmojis): Observable<void> {
    return this.http
      .post<void>(this.endpointURL(), counts.sortedEmojiUsages, JSON_CONTENT_TYPE_HEADER)
      .pipe(this.ehs.catchAlertAndThrowHttpError());
  }

  private endpointURL() {
    const companyId = this.alcmeonContext.companyId;
    return `${API_URL_PREFIX}/api/1.0/companies/${companyId}/users/self/persistent-frontend-data/emoji-usage-counts`;
  }
}
